import './stepper.style.css';

import { AlertTriangleIcon, Check } from 'lucide-react';
import React, { ReactElement } from 'react';

import {
  StepCounter,
  StepLabel,
  StepLine,
  StepperContainer,
  StepperWrapper,
  StepStyled,
  StepWrapper,
} from './Step.styled';

export interface StepperProps {
  steps: StepInterface[];
  activeStep: number;
  invalidStep?: number[];
  onStepClick?: (stepNumber: number) => void;
}
export interface StepInterface {
  name: string;
}

export const initializeSteps = (stepNames: string[]): StepInterface[] => (
  stepNames.map((stepName) => ({ name: stepName }))
);

export const Stepper = (props: StepperProps): ReactElement => {
  const { steps, activeStep, invalidStep, onStepClick } = props;
  const calculateClassName = (index: number) : string => {
    if (invalidStep?.includes(index)) return 'danger';
    if (index === activeStep) return 'active';
    return index > activeStep ? '' : 'visited';
  };

  const inValidStep = (step: number): boolean => step < 1 || step > steps.length;

  return (
    <StepperContainer className="stepper-container">
      <StepperWrapper data-testid="stepper">
        {steps.map((step: StepInterface, index: number) => {
          const stepNumber = index + 1;
          const isInvalid = invalidStep?.includes(stepNumber);
          return (
            <StepStyled
              className={`${calculateClassName(stepNumber)} cursor-pointer`}
              key={step.name}
              id={step.name}
              data-testid={`step_${stepNumber}`}
              onClick={() => onStepClick && onStepClick(stepNumber)}
            >
              <StepWrapper className="stepper-wrapper">
                <StepCounter>
                  {(activeStep > stepNumber && inValidStep(stepNumber)) ? (
                    <Check />
                  ) : (
                    !isInvalid && <span>{ stepNumber }</span>
                  )}
                  {isInvalid && <AlertTriangleIcon size={18} color="#c20e4d" />}
                </StepCounter>

                <StepLabel data-testid={`step_${stepNumber}_label`}>{step.name}</StepLabel>
              </StepWrapper>

              {steps.length - 1 !== index && <StepLine />}
            </StepStyled>
          );
        })}
      </StepperWrapper>
    </StepperContainer>
  );
};
